import React from 'react'
import ReactDOM from 'react-dom'
import B2BApp from './B2BApp'
import './5-styles/styles.scss'

ReactDOM.render(
  <B2BApp />,
  document.getElementById('root')
)
